module.exports = __webpack_public_path__ + "static/media/x.30ca0cb5.svg";